export default function MapLayoutToggle({ stacked, onToggle }) {
  const label = stacked ? 'Move details beside map' : 'Move details below map';
  return (
    <button
      type="button"
      className="map-layout-toggle"
      aria-label={label}
      aria-pressed={stacked}
      title={label}
      onClick={onToggle}
    >
      <i className={`pi ${stacked ? 'pi-window-minimize' : 'pi-window-maximize'}`} aria-hidden="true" />
    </button>
  );
}
